(ns frontend.view.entity-viewers.modules.pre-investment-checks.view
  (:require
   [common.localization :as loc]
   [common.schema.entities.pipeline :as pipeline]
   [common.schema.registry :as registry]
   [frontend.state.current-session :as session]
   [frontend.state.permissions :as f-permissions]
   [frontend.view.modals.events :as modals]
   [frontend.view.modals.pre-investment-check.view :as pre-investment-check-modal]
   [frontend.zap-time :as zap-time]))

(defn capman-pre-investment-check-order
  []
  [:oppo/dd-budget-check
   :oppo/fund-manager-check
   :oppo/legal-and-compliance-check
   :oppo/asset-kyc-check
   :oppo/esg-sfdr-check
   :oppo/risk-check])

(defn oppo-pre-investment-check-attributes
  "Check attributes readable on `oppo`, permissioned against the deal's own
   pipeline. Passing no pipeline here would fall back to the tenant-global
   field config and render checks the deal's pipeline has disabled."
  [tenant-schema oppo]
  (let [pipeline-id (pipeline/entity-pipeline oppo)]
    (->> (registry/get-schema tenant-schema :entity.type/oppo)
         (filter
          (fn [[_attribute field]]
            (-> field
                :field/entity-types
                set
                (contains? :entity.type/pre-investment-check))))
         keys
         (filter
          (fn [attribute]
            (let [can-read? (f-permissions/field-read-access? attribute
                                                              :entity.type/oppo
                                                              pipeline-id)]
              can-read?)))
         (map
          (fn [attribute]
            {:attribute attribute
             :order     (.indexOf (capman-pre-investment-check-order) attribute)}))
         (sort-by :order)
         (map :attribute))))

(defn view
  [tenant-schema entities oppo]
  (let [pipeline-id (pipeline/entity-pipeline oppo)]
    [:div
     {:class "pt-3 flex flex-col"}
     (->>
      (oppo-pre-investment-check-attributes tenant-schema oppo)
      (map
       (fn [attribute]
         (let [pre-investment-check-id (get oppo attribute)
               {:keys [pre-investment-check/note pre-investment-check/conditions pre-investment-check/checked-on
                       pre-investment-check/status]
                :as   pre-investment-check}
               (get entities pre-investment-check-id)
               excerpt (if (empty? conditions) note conditions)]
           [:div
            {:class    "w-full py-2 px-3 flex justify-between items-center border-b border-solid border-base-light-border-paler"
             :key      (str "pre-investment-check-" attribute)
             :on-click (fn []
                         (modals/open-modal!
                          pre-investment-check-modal/modal-key
                          {:attribute   attribute
                           :oppo-id     (:db/id oppo)
                           :read-only?  (not (f-permissions/field-write-access?
                                              attribute :entity.type/oppo pipeline-id))
                           :start-state pre-investment-check}))}
            [:div
             {:class "flex overflow-hidden cursor-pointer"}
             [:div
              {:class "flex items-center"}
              (case status
                :pre-investment-check.status/not-approved
                [:i.fas.fa-times-circle
                 {:class "text-danger-light-text"}]
                :pre-investment-check.status/approved
                [:i.fas.fa-check-circle
                 {:class "text-success-light-text"}]
                :pre-investment-check.status/conditionally-approved
                [:i.fas.fa-check-circle
                 {:class "text-warning-light-text-paler"}]
                [:i.fal.fa-circle
                 {:class "text-base-light-text"}])
              (when checked-on
                [:div
                 {:class "pl-3"}
                 (zap-time/long->formatted-date checked-on)])]
             [:div
              {:class "pl-3 truncate"}
              (loc/field-name attribute (registry/get-field-schema tenant-schema attribute))]]
            (when-not (empty? excerpt)
              [:div
               {:class "truncate max-w-[80px] w-[80px]"}
               excerpt])]))))]))

(defn header-view
  [tenant-schema entity]
  (let [attributes (oppo-pre-investment-check-attributes tenant-schema entity)
        total-count (count attributes)
        statuses (->> attributes
                      (map (partial get entity))
                      (map session/get-entity)
                      (map :pre-investment-check/status))
        done-count (->> statuses
                        (filter
                         #(or
                           (= % :pre-investment-check.status/approved)
                           (= % :pre-investment-check.status/conditionally-approved)))
                        count)]
    [:div
     {:class "flex gap-2 items-center"}
     [:div
      {:class "mb-0 font-normal text-sm"}
      (str done-count "/" total-count)]
     (cond
       (every? #{:pre-investment-check.status/approved} statuses)
       [:i.fas.fa-check-circle
        {:class "text-base-light-text-accent"}]
       (contains? (set statuses) :pre-investment-check.status/not-approved)
       [:i.fas.fa-times-circle
        {:class "text-danger-light-text"}]
       (every? #{:pre-investment-check.status/approved :pre-investment-check.status/conditionally-approved} statuses)
       [:i.fas.fa-check-circle
        {:class "text-warning-light-text"}]
       :else
       [:i.fal.fa-circle
        {:class "text-base-light-text-paler"}])]))
